export const IMAGE_CELL_RENDERER_MODES = {
    DEFAULT: 'default',
    COMFORTABLE: 'comfortable',
    ITEM_PREVIEW_GRID: 'itemPreviewGrid',
};
